var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_2586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.62508 4.58333C5.16508 4.58333 4.79175 4.21 4.79175 3.75V0.833333C4.79175 0.373333 5.16508 0 5.62508 0C6.08508 0 6.45841 0.373333 6.45841 0.833333V3.75C6.45841 4.21 6.08508 4.58333 5.62508 4.58333Z",
    fill: "#5E77F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 4.58333C9.12333 4.58333 8.75 4.21 8.75 3.75V0.833333C8.75 0.373333 9.12333 0 9.58333 0C10.0433 0 10.4167 0.373333 10.4167 0.833333V3.75C10.4167 4.21 10.0433 4.58333 9.58333 4.58333Z",
    fill: "#5E77F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5416 4.58333C13.0816 4.58333 12.7083 4.21 12.7083 3.75V0.833333C12.7083 0.373333 13.0816 0 13.5416 0C14.0016 0 14.3749 0.373333 14.3749 0.833333V3.75C14.3749 4.21 14.0016 4.58333 13.5416 4.58333Z",
    fill: "#5E77F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2084 1.875H3.95842C2.69425 1.875 1.66675 2.9025 1.66675 4.16667V17.7083C1.66675 18.9725 2.69425 20 3.95842 20H15.2084C16.4726 20 17.5001 18.9725 17.5001 17.7083V4.16667C17.5001 2.9025 16.4726 1.875 15.2084 1.875ZM5.83342 6.66667H10.0001C10.4601 6.66667 10.8334 7.04 10.8334 7.5C10.8334 7.96 10.4601 8.33333 10.0001 8.33333H5.83342C5.37342 8.33333 5.00008 7.96 5.00008 7.5C5.00008 7.04 5.37342 6.66667 5.83342 6.66667ZM14.1667 15H5.83342C5.37342 15 5.00008 14.6267 5.00008 14.1667C5.00008 13.7067 5.37342 13.3333 5.83342 13.3333H14.1667C14.6267 13.3333 15.0001 13.7067 15.0001 14.1667C15.0001 14.6267 14.6267 15 14.1667 15ZM14.1667 11.6667H5.83342C5.37342 11.6667 5.00008 11.2933 5.00008 10.8333C5.00008 10.3733 5.37342 10 5.83342 10H14.1667C14.6267 10 15.0001 10.3733 15.0001 10.8333C15.0001 11.2933 14.6267 11.6667 14.1667 11.6667Z",
    fill: "#5E77F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_2586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.89c5f8cf3df69d915cbdf230483504cc.svg";
export { ForwardRef as ReactComponent };